<template>
  <div class="basicInfo">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.basicInfo.companyName }}：{{ item.CompanyName }}
        </div>
        <div class="list-item">
          {{ $t.basicInfo.customerNumber }}：{{ item.CustomerNumber }}
        </div>
        <div class="list-item">
          {{ $t.basicInfo.customerPhone }}：{{ item.TelePhone }}
        </div>
        <div class="list-item">
          {{ $t.basicInfo.area }}：{{ item.CountryName }},{{ item.CityName }}
        </div>
        <div class="list-item">
          {{ $t.basicInfo.receivable }}
          <span v-if="settlementCurrency">({{ settlementCurrency }})</span>：{{
            item.ReceivedBalance
          }}
        </div>
        <div class="list-item">{{ $t.basicInfo.status }}：{{ item.StatueStr }}</div>
        <div class="buttons">
          <van-button
            :class="item.Statue == '1' ? 'default-btn' : 'search-btn'"
            size="small"
            type="primary"
            @click="editCustomerInfoStatue(item.CustomerId)"
          >
            <span v-if="item.Statue == '1'">{{ $t.meta.disable }}</span>
            <span v-else>{{ $t.meta.enable }}</span></van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoAgentList(item.CustomerNumber)"
            >{{ $t.basicInfo.operationInfo }}</van-button
          >
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.CustomerId)"
            >{{ $t.meta.editButton }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group v-model="customerType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.basicInfo.createType }}</div>
        <van-radio-group v-model="createType" direction="horizontal">
          <van-radio :name="1">{{ $t.basicInfo.createType1 }}</van-radio>
          <van-radio :name="2">{{ $t.basicInfo.createType2 }}</van-radio>
          <van-radio :name="3">{{ $t.basicInfo.createType3 }}</van-radio>
          <van-radio :name="4">{{ $t.basicInfo.createType4 }}</van-radio>
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.meta.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showBasicInfoCountry')"
        />

        <van-field
          clickable
          readonly
          :value="selectedCity.text"
          :label="$t.meta.city"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showBasicInfoCity')"
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showBasicInfoCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showBasicInfoCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.basicInfo.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "basicInfo",
  components: {
    OptionList,
  },
  data() {
    return {
      settlementCurrency: JSON.parse(localStorage.getItem("auth")).userInfo
        .SettlementCurrency,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      countryList: [],
      cityList: [],
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.basicInfo.customerNumber,
          value: 1,
        },
        {
          text: this.$t.basicInfo.companyName,
          value: 2,
        },
        {
          text: this.$t.basicInfo.addPeople,
          value: 3,
        },
        {
          text: this.$t.basicInfo.referrer,
          value: 4,
        },
      ],
      customerType: null,
      createType: null,
      showFilter: false,
      selectedCountry: { text: "", value: null },
      selectedCity: { text: "", value: null },
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  created() {
    this.getCountryList();
    this.getCityList();
  },
  methods: {
    gotoAgentList(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "basicInfoAgentList",
        name: "basicInfoAgentList",
        query: [
          {
            name: "CustomerNumber",
            value: id,
          },
        ],
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "basicInfoDetail",
        name: "basicInfoDetail",
        query: [
          {
            name: "CustomerId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.customerType ||
        this.createType ||
        this.selectedCountry.value ||
        this.selectedCity.value ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.customerType = null;
      this.createType = null;
      this.beginTime = "";
      this.endTime = "";
      this.selectedCountry = { text: "", value: null };
      this.selectedCity = { text: "", value: null };
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    editCustomerInfoStatue(id) {
      this.$commonMethod.showLoading();
      var param = {
        CustomerId: id,
      };
      this.$api.customerManagement
        .editCustomerInfoStatue(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CustomerType: this.customerType,
        CreateType: this.createType,
        CustomerNumber: this.searchType == 1 ? this.searchText : "",
        CompanyName: this.searchType == 2 ? this.searchText : "",
        AddUser: this.searchType == 3 ? this.searchText : "",
        ReferBy: this.searchType == 4 ? this.searchText : "",
        CountryId: this.selectedCountry.value,
        CityId: this.selectedCity.value,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.customerManagement
        .getCustomerInfoList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getCountryList() {
      this.$api.customerManagement
        .getCountryList()
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CountryName + "," + item.CountryName_en,
              value: item.CountryId,
            };
            result.push(data);
          });
          this.countryList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCityList() {
      this.$api.logisticsManagement
        .getCountryList({
          type: 1,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.City_cn + "," + item.City_en,
              value: item.Id,
            };
            result.push(data);
          });
          this.cityList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.basicInfo {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
